module.exports = __webpack_public_path__ + "a0eb5c7f5b156b36b7f2281f52436ef9.png";